import React, { Component } from "react";
import UniqueKey from "../common/UniqueKey";
// import Draggable, { DraggableCore } from "react-draggable";
import { UncontrolledTooltip, Badge } from "reactstrap";

class RadioCustom extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      ttid2: "TTID" + String(Math.round(Math.random() * 1000000000))
    };
  }
  generateID() {
    return this.state.ttid;
  }

  generateID2() {
    return this.state.ttid2;
  }

  handleChange(val) {
    let x = this.props.parentState.errorMessages;
    x[this.props.component.name] = "";
    this.props.liftGlobalState({ name: "errorMessages" }, x);
    this.props.liftState(this.props.component, val);
  }
  handleDrag(e, ui) {
    console.log(ui);
  }
  handleClear = () => {
    this.props.liftState({ name: this.props.component.name }, '');
  }
  componentDidMount() {
    let { fileFolder, formState, modalname, pageData } = this.props.parentState;
    let { name, displayData } = this.props.component;
    // console.log(this.props.component.default)
    if (
      pageData && !fileFolder.isOpen &&
      ((!modalname && !pageData[name]) || (modalname && (!pageData[modalname] || !pageData[modalname][name]))) &&
      this.props.component.default
    ) {

      this.props.liftState(this.props.component, this.props.component.default);
    }
  }
  render() {
    const { name, label, description, isReadOnly, style } = this.props.component;
    let { pageData, fileFolder, formState, openmodals, LocalVars } = this.props.parentState;
    let { compressed } = LocalVars;
    let isReadOnly1 = false;
    let { conditionalRender } = this.props;
    if ((pageData.unique_id && isReadOnly == 'edit') || (conditionalRender && conditionalRender == 'readonly') || (isReadOnly && isReadOnly != 'edit')) {
      isReadOnly1 = true;
    }

    let pgdate
    let modalname = openmodals[openmodals.length - 1];
    if (modalname && pageData[modalname]) {
      pgdate = pageData[modalname]
    } else {
      pgdate = pageData
    }
    const tooltipID = this.generateID();
    const tooltipID2 = this.generateID2();
    return (
      <div
        key={this.props.index}
        style={style ? style : {}}
        className={`form-group radio-container form-check form-check-inline ${this.props.component.widths.parent}`}
      >
        {this.props.component.options.map((val, index) => (
          <label
            className={`radio-compressed radio-label`}

            key={val.value + index + "-" + UniqueKey()}
          >
            <input
              className="radio-input radio-input-field"
              type="radio"
              name={name}
              value={val.value}
              checked={pgdate[name] === val.value}
              onChange={() => this.handleChange(val.value)}
              onDoubleClick={this.handleClear}
            />
            &nbsp;{val.label}
          </label>
        ))}
      </div>
    );
  }
}
export default RadioCustom;
